import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase } from '@interfaces/commonInterfaces'

export interface IState {
  categoryList?: any
  categoryOptionList?: any
  categoryDetail?: any
  reloadCategoryList?: string | null
  modalCategory?: IModalBase
}

const initialState: IState = {
  categoryList: [],
  categoryOptionList: [],
  categoryDetail: {},
  reloadCategoryList: null,
  modalCategory: {
    visible: false,
    record: {}
  }
}

export const categoryDucks = createSlice({
  name: 'category',
  initialState,
  reducers: {

    getListCategory: (state: RootState, action: PayloadAction<any>) => {
      state.categoryList = { loading: true, queryStr: action.payload }
    },
    getListCategorySuccess: (state, action: PayloadAction<any>) => {
      state.categoryList = { loading: false, ...action.payload }
    },
    getListCategoryFail: (state, action: PayloadAction<any>) => {
      state.categoryList = { loading: false, ...action.payload }
    },

    getListOptionCategory: (state: RootState, action: PayloadAction<any>) => {
      state.categoryOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionCategorySuccess: (state, action: PayloadAction<any>) => {
      state.categoryOptionList = { loading: false, ...action.payload }
    },
    getListOptionCategoryFail: (state, action: PayloadAction<any>) => {
      state.categoryOptionList = { loading: false, ...action.payload }
    },

    getDetailCategory: (state: RootState, action: PayloadAction<any>) => {
      state.categoryDetail = { loading: true, id: action.payload }
    },
    getDetailCategorySuccess: (state, action: PayloadAction<any>) => {
      state.categoryDetail = { loading: false, ...action.payload }
    },
    getDetailCategoryFail: (state, action: PayloadAction<any>) => {
      state.categoryDetail = { loading: false, ...action.payload }
    },

    setReloadCategoryList: (state: RootState) => {
      state.reloadCategoryList = String(moment())
    },
    setModalCategory: (state, action: PayloadAction<IModalBase>) => {
      state.modalCategory = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListCategory,
  getListCategorySuccess,
  getListCategoryFail,

  getListOptionCategory,
  getListOptionCategorySuccess,
  getListOptionCategoryFail,

  getDetailCategory,
  getDetailCategorySuccess,
  getDetailCategoryFail,

  setReloadCategoryList,
  setModalCategory
} = categoryDucks.actions

export default categoryDucks.reducer
